import { useState, useEffect } from "react";
import { X, Sparkles } from "lucide-react";
import { CHANGELOG, hasNewAnnouncement, dismissAnnouncement } from "@/config/changelog";
import { useWhatsNew } from "./WhatsNewModal";

export function AnnouncementBanner() {
  const [visible, setVisible] = useState(false);
  const { openWhatsNew, WhatsNewModalComponent } = useWhatsNew();

  useEffect(() => {
    setVisible(hasNewAnnouncement());
  }, []);

  const handleDismiss = () => {
    dismissAnnouncement();
    setVisible(false);
  };

  const handleClick = () => {
    openWhatsNew();
    handleDismiss();
  };

  if (!visible) return WhatsNewModalComponent;

  const latestNew = CHANGELOG.find(e => e.isNew);
  if (!latestNew) return null;

  return (
    <>
      <div className="bg-primary text-primary-foreground px-4 py-2 flex items-center justify-between gap-3 text-sm">
        <button
          onClick={handleClick}
          className="flex items-center gap-2 flex-1 text-left hover:opacity-80 transition-opacity"
        >
          <Sparkles className="h-4 w-4 shrink-0" />
          <span className="font-medium">New in v{latestNew.version}:</span>
          <span className="truncate">{latestNew.title}</span>
        </button>
        <button
          onClick={handleDismiss}
          className="p-1 hover:bg-primary-foreground/20 rounded transition-colors"
          aria-label="Dismiss announcement"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
      {WhatsNewModalComponent}
    </>
  );
}
